import FingerprintJS from "@fingerprintjs/fingerprintjs";

// Initialize the agent at application startup.
const fpPromise = FingerprintJS.load();

export const fingerPrint = async () => {
  // Get the visitor identifier when you need it.
  const fp = await fpPromise;
  const result = await fp.get();
  return result.visitorId;
};
